import { render, staticRenderFns } from "./PasswordSendEmail.vue?vue&type=template&id=58d4eec2"
import script from "./PasswordSendEmail.vue?vue&type=script&lang=js"
export * from "./PasswordSendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports